import { render, staticRenderFns } from "./WorkspaceFabricSetPerspective.vue?vue&type=template&id=4fbc3118&scoped=true&"
import script from "./WorkspaceFabricSetPerspective.vue?vue&type=script&lang=js&"
export * from "./WorkspaceFabricSetPerspective.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceFabricSetPerspective.vue?vue&type=style&index=0&id=4fbc3118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbc3118",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fbc3118')) {
      api.createRecord('4fbc3118', component.options)
    } else {
      api.reload('4fbc3118', component.options)
    }
    module.hot.accept("./WorkspaceFabricSetPerspective.vue?vue&type=template&id=4fbc3118&scoped=true&", function () {
      api.rerender('4fbc3118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/WorkspaceFabricSetPerspective.vue"
export default component.exports